<img *ngIf="imageBlobUrl" [src]="imageBlobUrl" [alt]="alternativeText" [height]="height" [width]="width" class="m-0" [ngClass]="cssClass"/>